module.exports = __webpack_public_path__ + "static/img/xinchou.2e8497e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinchou.png
// module id = qvx1
// module chunks = 1